import React, { Component } from "react";
import { OrderLegalDisclaimer } from "@hendrix/react-order-legal-disclaimer";
import Dialog from "@react/react-spectrum/Dialog";
import Checkbox from "@react/react-spectrum/Checkbox";
import Button from "@react/react-spectrum/Button";
import i18n from "../../i18n";
import { withTranslation } from "react-i18next";
import * as appConstants from "../../constants/AppConstants";
import approvalService from "../../services/ApprovalService";
import SafeHtml from "@pandora/react-safe-html";
import { Loader } from "@hendrix/react-loader";
import { extractDetails } from "../../services/approval-util";

export class CustomApproveDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableConfirmBtn: true,
      isDisclaimerCountry: false,
      orderId: "",
      locale: "",
      isLoadingOrderId: true,
      disclaimerDetailsData: null,
      isLoadingDisclaimer: false,
      showtermModal: false,
    };
    this.btnLabelName = "";
    this.handleCheckBoxEvent = true;
    this.close = this.close.bind(this);
    this.cancel = this.cancel.bind(this);
    this.checkBoxClick = this.checkBoxClick.bind(this);
    this.getTncContent = this.getTncContent.bind(this);
    this.fetchDisclaimer = this.fetchDisclaimer.bind(this);
  }

  componentDidMount() {
    const isDisclaimerCountry =
      (this.props.approvalMetaData &&
        this.props.approvalMetaData.isDisclaimerCountry) ||
      false;
    const orderId = extractDetails(this.props.approvalData, "id") || "";
    const locale = extractDetails(this.props.approvalData, "locale") || "";

    this.setState(
      {
        isDisclaimerCountry: isDisclaimerCountry,
        orderId: orderId,
        locale: locale,
        isLoadingOrderId: false,
      },
      () => {
        // Call fetchDisclaimer if disclaimer country is true
        if (this.state.isDisclaimerCountry && this.state.orderId) {
          this.fetchDisclaimer();
        }
      }
    );
  }

  componentDidUpdate(prevProps) {
    // Check if props have changed and update state accordingly
    const currentOrderId = extractDetails(this.props.approvalData,"id") || "";
    const currentIsDisclaimerCountry =
      (this.props.approvalMetaData &&
        this.props.approvalMetaData.isDisclaimerCountry) ||
      false;

    // Get previous values for comparison
    const prevOrderId = extractDetails(prevProps.approvalData,"id") || "";
    const prevIsDisclaimerCountry =
      (prevProps.approvalMetaData &&
        prevProps.approvalMetaData.isDisclaimerCountry) ||
      false;

    // Only update state if values have actually changed
    if (
      prevIsDisclaimerCountry !== currentIsDisclaimerCountry ||
      prevOrderId !== currentOrderId
    ) {
      this.setState(
        {
          isDisclaimerCountry: currentIsDisclaimerCountry,
          orderId: currentOrderId,
          isLoadingOrderId: false, // Set loading to false when props update
        },
        () => {
          // Call fetchDisclaimer if disclaimer country becomes true
          if (currentIsDisclaimerCountry && currentOrderId) {
            this.fetchDisclaimer();
          }
        }
      );
    }
  }

  close() {
    //alert('Close');
  }

  cancel() {
    //alert('Cancel');
  }

  fetchDisclaimer = async () => {
    // Set loading state
    this.setState({ isLoadingDisclaimer: true });
    try {
      const response = await approvalService.fetchDisclaimer(
        this.state.orderId,
        this.state.locale
      );

      // Store the response in state
      this.setState({
        disclaimerDetailsData: response.data.data.order,
        isLoadingDisclaimer: false,
      });
    } catch (error) {
      this.setState({ isLoadingDisclaimer: false });
    }
  };

  checkBoxClick(event) {
    this.setState({ disableConfirmBtn: !event });
  }

  getTncContent(localeLicenceStr) {
    if (
      this.props.approvalMetaData &&
      this.props.approvalMetaData.tncTemplate &&
      this.props.approvalMetaData.tncTemplate.templateName &&
      this.props.approvalMetaData.tncTemplate.dynamicValues &&
      this.props.approvalMetaData.tncTemplate.dynamicValues.licenseQuantity
    ) {
      let templateName = this.props.approvalMetaData.tncTemplate.templateName;
      this.handleCheckBoxEvent = false;
      this.btnLabelName = i18n.t(
        "tncTemplates." + templateName + ".okBtnLabel"
      );
      return (
        <div>
          <div
            className="terms-and-conditions"
            data-am-id="approveModalTermsAndCondInfo"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: i18n.t("tncTemplates." + templateName + ".text", {
                  customerSupportUrl: this.customerSupport,
                  termsOfUseLink: this.termsOfUseUrl,
                  cancellationTerms: this.cancellationTerms,
                  postProcess: "interval",
                  count:
                    this.props.approvalMetaData.tncTemplate.dynamicValues
                      .licenseQuantity,
                  adobeAccount: this.adobeAccount,
                  licenseStr: localeLicenceStr,
                }),
              }}
            />
          </div>
        </div>
      );
    } else if (
      this.props.approvalMetaData &&
      this.props.approvalMetaData.countryCode &&
      this.props.approvalMetaData.countryCode.indexOf(
        appConstants.AUTO_RENEWAL_COUNTRIES
      ) > -1 &&
      this.props.approvalMetaData.billingFrequency &&
      this.props.approvalMetaData.billingFrequency ===
        appConstants.BILLING_FREQUENCY_ANNUAL
    ) {
      this.btnLabelName = i18n.t(
        this.props.type + ".acceptAndSubscribeBtnLabel"
      );
      return (
        <div>
          <div
            className="terms-and-conditions"
            data-am-id="approveModalTermsAndCondInfo"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: i18n.t(this.props.type + ".approveBtn.tnc_US_PUF", {
                  customerSupportUrl: this.customerSupport,
                  termsOfUseLink: this.termsOfUseUrl,
                  cancellationTerms: this.cancellationTerms,
                  postProcess: "interval",
                  count: this.props.totalLicense,
                  licenseStr: localeLicenceStr,
                }),
              }}
            />
          </div>
          <Checkbox
            label={i18n.t(this.props.type + ".approveBtn.approveCheckboxLabel")}
            defaultCh
            onChange={this.checkBoxClick}
            data-am-id="approveModalCheckBox"
          />
        </div>
      );
    } else if (
      this.props.approvalMetaData &&
      this.props.approvalMetaData.countryCode &&
      this.props.approvalMetaData.countryCode.indexOf(
        appConstants.AUTO_RENEWAL_COUNTRIES
      ) > -1 &&
      this.props.approvalMetaData.billingFrequency ===
        appConstants.BILLING_FREQUENCY_MONTHLY
    ) {
      this.btnLabelName = i18n.t(
        this.props.type + ".acceptAndSubscribeBtnLabel"
      );
      return (
        <div>
          <div
            className="terms-and-conditions"
            data-am-id="approveModalTermsAndCondInfo"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: i18n.t(this.props.type + ".approveBtn.tnc_US_APM", {
                  customerSupportUrl: this.customerSupport,
                  termsOfUseLink: this.termsOfUseUrl,
                  cancellationTerms: this.cancellationTerms,
                  postProcess: "interval",
                  count: this.props.totalLicense,
                  licenseStr: localeLicenceStr,
                }),
              }}
            />
          </div>
          <Checkbox
            label={i18n.t(this.props.type + ".approveBtn.approveCheckboxLabel")}
            defaultCh
            onChange={this.checkBoxClick}
            data-am-id="approveModalCheckBox"
          />
        </div>
      );
    } else {
      this.btnLabelName = i18n.t(this.props.type + ".okBtnLabel");
      return (
        <div>
          <div
            className="terms-and-conditions"
            data-am-id="approveModalTermsAndCondInfo"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: i18n.t(this.props.type + ".approveBtn.approveDesc", {
                  termsOfUseLink: this.termsOfUseUrl,
                  cancellationTerms: this.cancellationTerms,
                  postProcess: "interval",
                  count: this.props.totalLicense,
                  licenseStr: localeLicenceStr,
                }),
              }}
            />
          </div>
          <Checkbox
            label={i18n.t(this.props.type + ".approveBtn.approveCheckboxLabel")}
            defaultCh
            onChange={this.checkBoxClick}
            data-am-id="approveModalCheckBox"
          />
        </div>
      );
    }
  }

  render() {
    if (this.props.locale !== "en") {
      let splittedLocale = this.props.locale.split("-");
      let goUrlLocale = "";
      if (splittedLocale.length === 2) {
        goUrlLocale = splittedLocale[0] + "_" + splittedLocale[1].toUpperCase();
      } else {
        goUrlLocale = this.props.locale;
      }

      this.termsOfUseUrl =
        this.props.getStandardGoUrls.termsOfUseUrl + "_" + goUrlLocale;
      this.cancellationTerms =
        this.props.getStandardGoUrls.cancellationTerms + "_" + goUrlLocale;
      this.customerSupport =
        this.props.getStandardGoUrls.customerSupportUrl + "_" + goUrlLocale;
      this.adobeAccount =
        this.props.getStandardGoUrls.adobeAccountUrl + "_" + goUrlLocale;
    } else {
      this.termsOfUseUrl = this.props.getStandardGoUrls.termsOfUseUrl;
      this.cancellationTerms = this.props.getStandardGoUrls.cancellationTerms;
      this.customerSupport = this.props.getStandardGoUrls.customerSupportUrl;
      this.adobeAccount = this.props.getStandardGoUrls.adobeAccountUrl;
    }
    const localeLicenceStr =
      this.props.totalLicense > 1
        ? i18n.t(this.props.type + ".approveBtn.multiLicense")
        : i18n.t(this.props.type + ".approveBtn.singleLicense");

    return (
      <div data-am-id="approveModal">
        {!this.state.showtermModal && (
          <Dialog
            modalContent
            onClose={this.close}
            title={i18n.t(this.props.type + ".approveBtn.approveTitle")}
            confirmLabel={
              this.state.isDisclaimerCountry
                ? i18n.t("agreeAndContinue")
                : this.btnLabelName
            }
            cancelLabel={i18n.t(this.props.type + ".cancelBtnLabel")}
            confirmDisabled={
              (this.state.isDisclaimerCountry
                ? this.state.isLoadingDisclaimer ||
                  !this.state.disclaimerDetailsData ||
                  (this.state.disableConfirmBtn && this.handleCheckBoxEvent)
                : false) ||
              (this.state.disableConfirmBtn && this.handleCheckBoxEvent)
            }
            onConfirm={this.props.confirm}
            onCancel={this.cancel}
            {...this.props}
          >
            {!this.state.isDisclaimerCountry ? (
              this.getTncContent(localeLicenceStr)
            ) : (
              <>
                {this.state.isLoadingDisclaimer ? (
                  <div className="disclaimer-loading">
                    <Loader message="Loading disclaimer details..." />
                  </div>
                ) : this.state.disclaimerDetailsData ? (
                  <div style={{ overflow: "auto" }}>
                    <OrderLegalDisclaimer
                      disclaimerDetailsData={this.state.disclaimerDetailsData}
                      isInternalPopupRequired={true}
                      onSubCanTermOpenCallBack={() =>
                        this.setState({ ...this.state, showtermModal: true })
                      }
                    />
                  </div>
                ) : (
                  <div className="disclaimer-error">
                    <p>Failed to load disclaimer information</p>
                    <Button onClick={this.fetchDisclaimer} variant="cta">
                      Retry Disclaimer
                    </Button>
                  </div>
                )}
              </>
            )}
          </Dialog>
        )}
        {this.state.showtermModal && (
          <Dialog
            confirmLabel="Close"
            onConfirm={() =>
              this.setState({ ...this.state, showtermModal: false })
            }
          >
            <div style={{ overflow: "auto" }}>
              <SafeHtml
                dataTestId="subs-cancelaltion-content"
                html={
                  this.state.disclaimerDetailsData.terms[1]
                    .subCanTermsContent || ""
                }
              />
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}

export default withTranslation()(CustomApproveDialog);
